function basename(path: string): string {
  const n = path.trim();
  if (!n) return '';
  const i = Math.max(n.lastIndexOf('/'), n.lastIndexOf('\\'));
  return i >= 0 ? n.slice(i + 1) : n;
}

function looksLikeServerPath(name: string): boolean {
  return name.startsWith('/') || name.startsWith('\\') || /\/dms[-_]/i.test(name);
}

/** DMS storage keys are often UUID-based filenames returned in `original_file_name`. */
export function looksLikeStorageKey(name: string): boolean {
  const base = basename(name);
  if (!base) return false;
  if (looksLikeServerPath(name)) return true;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}(\.[a-z0-9]+)?$/i.test(base);
}

/**
 * Normalize `file_name` / `original_file_name` from case-request document APIs.
 * Steps GET may return the user-facing label in `file_name` and the DMS key in `original_file_name`.
 */
export function normalizeDocumentFileFields(
  apiFileName: string,
  apiOriginalFileName: string | null | undefined,
): { fileName: string; originalFileName: string } {
  const file = apiFileName.trim();
  const original =
    apiOriginalFileName === null || apiOriginalFileName === undefined
      ? ''
      : String(apiOriginalFileName).trim();

  if (file && original && looksLikeStorageKey(original) && !looksLikeStorageKey(file)) {
    return { fileName: original, originalFileName: file };
  }

  return {
    fileName: file,
    originalFileName: original,
  };
}

/** UI label: user-facing name (not DMS storage key or server path). */
export function displayClientFileName(originalFileName?: string | null, storedFileName?: string): string {
  if (originalFileName === null && !storedFileName?.trim()) return '—';

  const display = basename(originalFileName?.trim() ?? '');
  if (display && !looksLikeStorageKey(display) && !looksLikeServerPath(display)) return display;

  const stored = basename(storedFileName?.trim() ?? '');
  if (stored && !looksLikeStorageKey(stored) && !looksLikeServerPath(stored)) return stored;

  if (originalFileName !== undefined && !display) return stored || '—';
  return display || stored || '—';
}
